import { makeStyles } from '@mui/styles';

const appBarHeight = '88px';

export const useNavStyles = makeStyles((theme) => ({
  navWrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    maxWidth: '100%',
    zIndex: 999,
    height: appBarHeight,
    color: 'white',
    backgroundColor: 'white !important',
  },

  opaque: {
    backgroundColor: 'white !important',
    color: `${theme.palette.text.main} !important`,
  },

  brandLogo: {
    overflow: 'hidden',
    height: '80px',
    [theme.breakpoints.down('lg')]: {
      height: 60,
      marginRight: '8px !important',
    },

    '& .img-logo': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      objectPosition: 'left',
    },
  },

  tnLinks: {
    display: 'flex',
    listStyle: 'none',
    margin: 0,

    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },

  tnMenu: {
    display: 'none !important',

    [theme.breakpoints.down('lg')]: {
      display: 'block !important',
    },
  },

  navClearence: {
    paddingTop: appBarHeight,
  },
}));
